import { EyeInvisibleOutlined } from '@ant-design/icons';
import React from 'react';
import { getSimpleWidgetReference } from '../../../../expressions/references/builder/getSimpleWidgetReference';
import { CustomWarningsRule } from '../../../../rules/repository/custom-warnings/CustomWarnings.rule';
import { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { InputCommonTranslationSchema } from '../../translations/InputCommonTranslationSchema';
import { HiddenWidgetComponent } from './HiddenWidgetComponent';
import {
  HiddenWidgetConfigComponent,
  HiddenWidgetConfigSchema,
} from './HiddenWidgetConfigComponent';
import { HiddenWidgetPreviewComponent } from './HiddenWidgetPreviewComponent';
import { IHiddenWidget } from './IHiddenWidget';
import { createHiddenWidgetSchema } from './createHiddenWidgetSchema';

export const HiddenWidgetType: IWidgetType<IHiddenWidget> = {
  type: WidgetType.Hidden,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Input,
  name: 'Campo nascosto',
  icon: <EyeInvisibleOutlined />,
  hasValue: true,
  getReference: (path, widget) => {
    return getSimpleWidgetReference(widget.dataType)(path, widget);
  },
  formComponent: HiddenWidgetComponent,
  createFormSchema: createHiddenWidgetSchema,
  previewComponent: HiddenWidgetPreviewComponent,
  configValidator: HiddenWidgetConfigSchema,
  configComponent: HiddenWidgetConfigComponent,
  translationSchema: InputCommonTranslationSchema,
  rules: [CustomWarningsRule],
  // Non mostrare le regole di visualizzazione
  hideFlags: true,
  dynamicReference: true,
};
